<template>
  <div class="d-flex">
    <div class="d-flex justify-content-between align-items-baseline w-100">
      <div v-if="perPage" class="d-flex align-items-center">
        <div>Show &nbsp;</div>
        <div class="page-option">
          <select
            v-model="perPage"
            aria-label="Default select"
            class="form-select"
            @change="changeRow"
          >
            <option v-for="data in pageOptions" :key="data" :value="data">
              {{ data }} Entries
            </option>
          </select>
        </div>
        <div>&nbsp;Per Page</div>
      </div>
      <nav v-if="currentPage" aria-label="Page navigation ">
        <ul class="pagination">
          <li :class="isInFirstPage ? 'disabled' : ''" class="page-item">
            <span
              tabindex="0"
              class="page-link"
              @click="changePage(currentPage - 1)"
            >
              <i class="fas fa-angle-left"></i>
            </span>
          </li>
          <li
            v-for="item in onlyShow.slice(0, 1)"
            :key="item"
            class="page-item disabled"
          >
            <span v-if="item > 1" class="page-link">...</span>
          </li>
          <li
            v-for="index in onlyShow"
            :key="index"
            :class="currentPage === index ? 'active' : ''"
            class="page-item"
          >
            <span tabindex="0" class="page-link" @click="changePage(index)">{{
              index
            }}</span>
          </li>
          <li
            v-if="onlyShow[onlyShow.length - 1] != totalPage"
            class="page-item disabled"
          >
            <span class="page-link">...</span>
          </li>
          <li :class="isInLastPage ? 'disabled' : ''" class="page-item">
            <span
              tabindex="0"
              class="page-link"
              @click="changePage(currentPage + 1)"
            >
              <i class="fas fa-angle-right"></i>
            </span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 1,
    },
    pageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
  },
  data() {
    return {
      perPage: this.size,
      currentPage: 1,
      // assume data count 50
    };
  },
  computed: {
    totalPage() {
      const data = Math.ceil(this.total / this.perPage);

      return data;
    },
    onlyShow() {
      var data = [];
      var page = this.currentPage;
      var start = Math.max(0, page - 2);
      var end = Math.min(start + 3, this.total);
      for (var i = start; i < end; i++) {
        if (this.totalPage > i) {
          data.push(i + 1);
        }
      }
      return data;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPage;
    },
  },
  methods: {
    changeRow() {
      this.currentPage = 1;
      console.log("CHANGE ROW");
      this.$emit("onChange", {page: this.currentPage, size: this.perPage})
    },
    changePage(index) {
      this.currentPage = index;
      // ============
      console.log("CHANGE PAGE");
      this.$emit("onChange", {page: this.currentPage, size: this.perPage})
    },
  },
};
</script>

<style scoped>
.pagination {
  border-radius: 4px;
  background-color: white !important;
  padding: 6px 8px !important;
  border: 1px solid #e6eaf5;
  margin-bottom: 0;
}

.page-item.active .page-link {
  background-color: #ff434f !important;
  border-color: #ff434f !important;
  color: #fff !important;
  border-radius: 4px;
}

.page-link {
  color: #cccccd !important;
  border: 0px !important;
  cursor: pointer;
}

.page-link:hover {
  background-color: #ff434f !important;
  border-color: #ff434f !important;
  color: #fff !important;
  border-radius: 4px;
}

.page-link:focus {
  box-shadow: 0 0 0 0.25rem rgba(94, 80, 161, 0.25);
}
</style>
